import React from "react";
import type { ChatMessage, ChatHistoryResponse } from "@/types/discuss.types";
import { UserMessageBlock } from "./UserMessageBlock";
import { AssistantMessageBlock } from "./AssistantMessageBlock";

interface ChatMessageItemProps {
  message: ChatMessage;
  index: number;
  isLastItem: boolean;
  hasActiveTask: boolean;
  isCompassProcessing: boolean;
  isSendingMessage: boolean;
  lastMessageRef: React.RefObject<HTMLDivElement>;
  doc: { _id?: string; title?: string } | undefined;
  historyData: ChatHistoryResponse | undefined;
  onRelatedQuestionClick: (question: string) => void;
}

export const ChatMessageItem: React.FC<ChatMessageItemProps> = ({
  message,
  index,
  isLastItem,
  hasActiveTask,
  isCompassProcessing,
  isSendingMessage,
  lastMessageRef,
  doc,
  historyData,
  onRelatedQuestionClick,
}) => {
  const hasQuestion = message.question != null && message.question.length > 0;
  const hasResponse = message.response != null && message.response.length > 0;
  const isLastAssistant = isLastItem && hasResponse;

  return (
    <React.Fragment>
      {hasQuestion && (
        <UserMessageBlock
          question={message.question ?? ""}
          creationDate={message.creation_date}
          isLastItem={isLastItem}
          hasResponse={hasResponse}
          hasActiveTask={hasActiveTask}
          lastMessageRef={lastMessageRef}
        />
      )}
      {hasResponse && (
        <AssistantMessageBlock
          message={message}
          index={index}
          isLastItem={isLastItem}
          isLastAssistant={isLastAssistant}
          hasActiveTask={hasActiveTask}
          isCompassProcessing={isCompassProcessing}
          isSendingMessage={isSendingMessage}
          lastMessageRef={lastMessageRef}
          doc={doc}
          historyData={historyData}
          onRelatedQuestionClick={onRelatedQuestionClick}
        />
      )}
    </React.Fragment>
  );
};
